import React from "react";
import styles from "../styles/HeroHeader.module.css";

const HeroHeader = ({
  eyebrow,
  heading,
  copy,
  imageSrc,
  imageAlt = "Traditional interior",
}) => {
  const hasIntro = Boolean(eyebrow || heading || copy);

  return (
    <section className={styles.hero}>
      <div className={styles.imageWrapper}>
          <div className={`${styles.imageWrapper} contentWrapper`}>
            <div className={styles.imageContainer}>
              {imageSrc ? <img src={imageSrc} alt={imageAlt} className={styles.image} /> : null}
            </div>
          </div>
      </div>

      <div className={`${styles.textWrapper} `}>
        {hasIntro ? (
          <>
            {eyebrow ? <p className={styles.eyebrow}>{eyebrow}</p> : null}
            {heading ? <h1 className={styles.heading}>{heading}</h1> : null}
            {copy ? <p className={styles.text}>{copy}</p> : null}
          </>
        ) : (
          <p className={styles.text}>
            Hodson Timber supplies quality timber, joinery, and bespoke solutions, backed by generations of
            experience and a reputation for reliability, craftsmanship, and personal service.
          </p>
        )}
      </div>
    </section>
  );
};

export default HeroHeader;
